import { ewsVerificationStates, states } from '@global/constants/states';
import { ProfileVerifications } from '@global/constants/verification';

export const CAPTCHA_VERIFICATIONS = ['dl', 'voter-id'];

export const CAPTCHA_FIELDNAME = 'captchaText';
export const CAPTCHA_TOKEN_FIELDNAME = 'token';

export const DOC_FIELDNAME: Record<string, string> = {
  [ProfileVerifications.BGV_EMPLOYMENT]: 'documentUrl'
};

export const PREDEFINED_OPTIONS: Record<string, unknown[]> = {
  INDIAN_STATE: states,
  EWS_VERIFICATION_STATES: ewsVerificationStates
};
